(() => {
  const loader = document.currentScript;
  if (!loader) return;
  let started = false;
  const events = ['pointerdown', 'keydown', 'touchstart'];
  function load(src) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.async = false;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }
  function start() {
    if (started) return;
    started = true;
    events.forEach(event => window.removeEventListener(event, start, true));
    load(loader.dataset.vendorSrc).then(() => load(loader.dataset.coreSrc)).catch(() => {});
  }
  events.forEach(event => window.addEventListener(event, start, {once:true, capture:true, passive:true}));
  function afterLoad() {
    window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
      if ('requestIdleCallback' in window) window.requestIdleCallback(start, {timeout:1500});
      else window.setTimeout(start, 100);
    }));
  }
  if (document.readyState === 'complete') afterLoad();
  else window.addEventListener('load', afterLoad, {once:true});
})();
